import { useCallback } from "react";

import { Box, SimpleGrid } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { DatePicker, TextInput } from "components";
import SectionTitle from "pages/clients/view/components/section-title";

interface EmploymentPreviousEmployerProps {
  index: number;
  employmentForm: UseFormReturnType<any>;
  localVisibleFields: string[];
  readOnly: boolean;
}

export const EmploymentPreviousEmployer = ({
  index,
  employmentForm,
  localVisibleFields,
  readOnly,
}: EmploymentPreviousEmployerProps) => {
  const { t } = useTranslation();

  const getPreviousEmployerMaxDate = useCallback(
    (index: number) => {
      const employment = employmentForm.getValues()?.[index];
      if (!employment?.contractStartDate) {
        return new Date();
      }

      const contractDate = moment(employment.contractStartDate);
      return contractDate.subtract(1, "month").endOf("month").toDate();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const isPreviousEmployerVisible =
    localVisibleFields.includes(`employments.${index}.previousEmployerName`) &&
    localVisibleFields.includes(`employments.${index}.previousEmployerStartDate`);

  if (!isPreviousEmployerVisible) {
    return null;
  }

  return (
    <Box mt={"md"} mb={40}>
      <SectionTitle label={t("bankCredit.previousEmployer.sectionTitle")} isBankCredit />
      <SimpleGrid cols={4}>
        <TextInput
          label={t("bankCredit.previousEmployerName.label")}
          key={employmentForm.key(`${index}.previousEmployerName`)}
          {...employmentForm.getInputProps(`${index}.previousEmployerName`)}
          disabled={readOnly}
        />
        <DatePicker
          label={t("bankCredit.previousEmployerStartDate.label")}
          key={employmentForm.key(`${index}.previousEmployerStartDate`)}
          {...employmentForm.getInputProps(`${index}.previousEmployerStartDate`)}
          maxDate={getPreviousEmployerMaxDate(index)}
          disabled={readOnly}
        />
      </SimpleGrid>
    </Box>
  );
};
